import { CommissionTier, CommissionBreakdownRow } from "../../../store/services/affiliate/dto/affiliate.dto";

// dummy data - not wired to any API yet
export const COMMISSION_TIERS: CommissionTier[] = [
	{ upTo: 10000, rate: 0.18 },
	{ upTo: 20000, rate: 0.22 },
	{ upTo: 40000, rate: 0.26 },
	{ upTo: Infinity, rate: 0.3 }
];

export const calculateCommissionBreakdown = (
	totalSales: number,
	tiers: CommissionTier[] = COMMISSION_TIERS
): CommissionBreakdownRow[] => {
	const rows: CommissionBreakdownRow[] = [];
	let remaining = totalSales;
	let lowerBound = 0;

	for (const tier of tiers) {
		if (remaining <= 0) break;
		const salesInTier = Math.min(remaining, tier.upTo - lowerBound);
		rows.push({ from: lowerBound, to: tier.upTo, rate: tier.rate, salesInTier, commission: salesInTier * tier.rate });
		remaining -= salesInTier;
		lowerBound = tier.upTo;
	}

	return rows;
};

export const calculateTotalCommission = (totalSales: number, tiers: CommissionTier[] = COMMISSION_TIERS): number =>
	calculateCommissionBreakdown(totalSales, tiers).reduce((sum, row) => sum + row.commission, 0);
